import React from "react";

import { type Table } from "@north-beam/nb-common";
import { downloadCsv, type ReportType } from "@utils/csv";

import { SecondaryButton } from "./secondary-button";

interface ExportToCsvProps {
  reportType: ReportType;
  fileName: string;
  data: Table;
}

export const ExportToCsv = ({
  reportType,
  fileName,
  data,
}: ExportToCsvProps) => (
  <SecondaryButton onClick={() => downloadCsv(reportType, fileName, data)}>
    EXPORT TO CSV
  </SecondaryButton>
);
